import { useState } from 'react';
import { CalendarArrowDown } from 'lucide-react';
import DailyReportModal from './DailyReportModal';

/**
 * "Download Daily Report" — replaces the generic ExportMenu for the Manager
 * role. Opens a date-picker modal; the backend generates a Sorigin-branded,
 * portfolio-wide Location → Project → Engineer report for that date (PDF or
 * Excel). Dashboard filters do not apply — this is the whole active portfolio.
 */
export default function DailyReportButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex h-9 items-center gap-1.5 rounded-xl px-3.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-white transition hover:bg-[#2d5c47]"
        style={{
          backgroundColor: '#264f3c',
          border: '1px solid rgba(11,59,46,0.45)',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.12)',
        }}
      >
        <CalendarArrowDown className="h-3.5 w-3.5" />
        Download Daily Report
      </button>
      <DailyReportModal
        open={open}
        onClose={() => setOpen(false)}
        title="Download Daily Report"
        description="Covers every engineer across all locations & projects for the selected date, grouped by location. Dashboard filters don't apply."
        formats={['pdf', 'xlsx']}
      />
    </>
  );
}
